const VERSION = process.env.NEXT_PUBLIC_PUBLIC_VERSION || 'unknown';
const ENV = process.env.NEXT_PUBLIC_ENVIRONMENT || process.env.NODE_ENV;

export const RP_AGENT_HEADER = 'X-Resortpass-Agent';
export const RP_AGENT_ID = 'www-next';

export const makeResortPassAgent = (env: string = ENV, version: string = VERSION) =>
  `${RP_AGENT_ID}:${env}:${version}`;

export const makeResortPassAgentHeader = () => ({
  [RP_AGENT_HEADER]: makeResortPassAgent(),
});
